export default function Footer() {
  return (
    <footer className="w-full py-4 mt-8 text-center text-xs text-muted-foreground border-t border-border/60">
      2026 | Developed by LionReach Labs
    </footer>
  );
}
